﻿import Signer from "./DSigner/Signer";
import type FormEngine from "./FormEngine";

export function initWorkdesk(formEngine: FormEngine) {
  var btnValid = document.createElement("button");
  btnValid.innerText = "Validuj";
  btnValid.classList.add("govuk-button");
  btnValid.onclick = () => {
    formEngine.form.validate();
  };

  var btnValidateWithXsd = document.createElement("button");
  btnValidateWithXsd.innerText = "Skontroluj s xsd";
  btnValidateWithXsd.classList.add("govuk-button");
  btnValidateWithXsd.onclick = () => {
    formEngine.form.validateWithXsd();
  };

  var btnInit = document.createElement("button");
  btnInit.innerText = "Clear";
  btnInit.classList.add("govuk-button");
  btnInit.onclick = () => {
    formEngine.form.reset();
  };

  var languageSelect = document.createElement("select");
  languageSelect.style.marginTop = "5px";
  languageSelect.classList.add("govuk-button");
  var languages = [
    {
      code: "SK",
      text: "Slovensky",
    },
    {
      code: "EN",
      text: "Anglicky",
    },
  ];
  for (var i = 0; i < languages.length; i++) {
    var option = document.createElement("option");
    option.value = languages[i].code;
    option.text = languages[i].text;
    if (window.FormEngine.translation.currentLanguage == languages[i].code) {
      option.selected = true;
    }
    languageSelect.appendChild(option);
  }
  languageSelect.onchange = (event) => {
    console.log(languageSelect.value);
    formEngine.translation.changeLanguage(languageSelect.value as string);
  };

  var btnLoad = document.createElement("input");
  btnLoad.setAttribute("type", "file");
  btnLoad.setAttribute("accept", "file_extension | audio/*|video/*|image/*|media_type");
  btnLoad.innerText = "Načítaj";
  btnLoad.classList.add("govuk-button");
  btnLoad.addEventListener("change", (event: Event) => {
    let target = event.target as HTMLInputElement;
    if (target) {
      formEngine.xmlService.importXml((target.files as FileList)[0], false).then(() => {
        btnLoad.value = "";
      });
    }
  });

  var btnSave = document.createElement("button");
  btnSave.innerText = "Ulož";
  btnSave.classList.add("govuk-button");
  btnSave.onclick = () => {
    formEngine.xmlService.exportXml();
  };

  var btnSign = document.createElement("button");
  btnSign.innerText = "Podpis";
  btnSign.classList.add("govuk-button");
  btnSign.setAttribute("id", "pospisat-button-workdesk");
  btnSign.onclick = () => {
    let xml = formEngine.xmlService.exportXmlAsString();
    //console.log(xml);
    //xml = xml.replace("FR7","a");
    //console.log(xml);
    let xsd = Signer.b64DecodeUnicode(formEngine.structure.structureJSON.xsdBase64);
    let xslt = Signer.b64DecodeUnicode(formEngine.structure.structureJSON.xsltBase64);
    //console.log(xml,xsd);
    formEngine.signer.sign(xml, xsd, xslt, "Desc striiinggg").then((result) => {
      console.log(result);
    });
  };

  var div = document.createElement("div");
  div.classList.add("wd-buttons");

  div.appendChild(btnValid);
  div.appendChild(btnValidateWithXsd);
  div.appendChild(btnInit);
  div.appendChild(btnLoad);
  div.appendChild(btnSave);
  div.appendChild(btnSign);
  div.appendChild(languageSelect);

  document.body.appendChild(div);
}
